<template>
    <div :class='classObj'>
        <label class='radio'>
            <input type='radio' :key='getKey' :id='id' :checked="isChecked" :value='value' :name='selectValue' @focus='validate' @blur='validate' @change='changeHandler'>
            <span>{{ label }}</span>
        </label>
       <!-- <span class='validationMessage'>{{ validationMessage }}</span> -->
    </div>
</template>
<script>
    export default{
        name: 'Radio',
        props: ['label', 'name', 'store', 'id', 'value', 'validationRules', 'disabled'],
        data() { 
            return{
                validationMessages: [],
                isFocused: false
            }
        },
        computed: {
             
            isChecked(){
                return this.$props.value == this.selectValue
            },
            selectValue: {
                get () { return this.$store.getters[this.$props.store + '/' + this.$props.name] },
                set (value) { return this.$store.dispatch(this.$props.store + '/set', {field: this.$props.name, value}) },
            },
             classObj(){
                return {
                    Radio: true,
                    'has-error': this.valid == false || this.$props.hasErrors == true,
                    'has-success': this.valid == true,
                    'is-disabled': this.isDisabled == true,
                    'is-focused': this.isFocused == true
                }
            },
            getKey(){ return this.$props.store + '_' + this.$props.name },
            isDisabled() { return this.$props.disabled || false },
            valid(){ return this.validationMessages.length == 0 ? true : false },
            validationMessage() { return this.validationMessages.join(', ') },
            placeholder() { return this.$props.placeholder || '' },
        },
        methods:{
            changeHandler(){
                this.selectValue = this.$props.value;
            },
            validate(e){
                //console.log('validate - ' + e.type);
                if(e.type == 'focus') this.isFocused = true;
                if(e.type == 'blur') this.isFocused = false;
                this.validationMessages = [];
                var rules = this.$props.validationRules || [];
                if(e.target.checkValidity() == false)
                    this.validationMessages.push('Please enter a valid value')
                else{
                    rules.forEach(rule => {
                        switch(rule){
                            case 'required':
                                if(!e.target.value)
                                this.validationMessages.push('This field is required')
                            break;
                        }
                    });
                }

                this.$emit('validate-field', { field: this.$props.name, status: this.valid})
            },
        }
    }
</script>